// Remediation and re-test state text, shared with pages that list or edit those states
// (DESIGN_SYSTEM.md §10.7). Kept beside TruthLabel, which renders them with their shapes.
import type { RemediationState, RetestState } from './TruthLabel.tsx';

export const REMEDIATION_LABELS: Record<RemediationState, string> = {
  NOT_STARTED: 'Not started',
  IN_PROGRESS: 'In progress',
  AWAITING_RETEST: 'Awaiting re-test',
  ACCEPTED_RISK: 'Accepted risk',
  COMPLETED: 'Remediation complete',
};

export const RETEST_LABELS: Record<RetestState, string> = {
  NOT_RECORDED: 'Not recorded',
  FIXED: 'Fixed in recorded re-test',
  STILL_VULNERABLE: 'Still vulnerable',
  INCONCLUSIVE: 'Inconclusive',
  UNABLE_TO_TEST: 'Unable to test',
};
